import { Color, SearchTrigger, TableBody, TableScroller, VerticalFlex } from "@enxcs/dap-ui-stratos";
import styled, { css } from "styled-components";

export const TableContentContainer = styled(TableScroller)`
  width: 100%;
  height: 208px;
  border-radius: 8px;

  & [role="columnheader"]:first-child,
  & [role="cell"]:first-child {
    border-right: none;
  }
`;

export const StyledSearch = styled(SearchTrigger)`
  width: 100%;
`;

export const TableBodyContainer = styled(TableBody)<{ isLoading: boolean }>`
  & [role="row"] {
    cursor: ${({ isLoading }) => (isLoading ? "default" : "pointer")};
  }

  & [role="cell"] {
    ${({ isLoading }) =>
      isLoading &&
      css`
        padding: 0px;
      `}
  }
`;

export const LoadingContainer = styled(VerticalFlex)`
  width: 100%;
  height: 150px;
  justify-content: center;
  align-items: center;
  background-color: ${Color.Neutral.V00};
  margin: 0;
  padding: 0;
`;
